import styled from '@emotion/styled';

export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
